export const SESSION_TOKEN_NAME = 'VcdDRUDv74M3rymdw14cw'
export const SESSION_SALT_NAME = '6r2dINy0XqYX82IJ1QCEdn'

export const SESSION_HEADER_NAME = 'kbgr8jmwl3r1ffbw3nilg'
export const SESSION_HEADER_SALT = 'tc4gftmj5twjryy3bxcbqs3n'

export const OTP_SESSION_IS_ACTIVE = 'ftOtpSessionIsActive'
